import React from 'react'
import AdmAttendanceUpdate from '../../components/AdminTabs/AdminAttendanceUpdate/AdmAttendanceUpdate'

const AttendanceUpdate = () => {
  return (
    <div>
        <AdmAttendanceUpdate />
    </div>
  )
}

export default AttendanceUpdate